export default "__VITE_ASSET__BUTmr6YB__"